import { useState, useEffect } from 'react';

var useIsMobile = function useIsMobile() {
  var _useState = useState(false),
    isMobile = _useState[0],
    setIsMobile = _useState[1];
  useEffect(function () {
    if (typeof window === 'undefined') {
      return undefined;
    }
    var media = window.matchMedia('(max-width: 44.9375em)');
    setIsMobile(media.matches);
    var listener = function listener(query) {
      setIsMobile(query.matches);
      return null;
    };
    if (media.addEventListener) {
      media.addEventListener('change', listener);
    } else {
      media.addListener(listener);
    }
    return function () {
      if (media.removeEventListener) {
        media.removeEventListener('change', listener);
      } else {
        media.removeListener(listener);
      }
    };
  }, []);
  return isMobile;
};

export { useIsMobile };
